<style lang="scss">
    .img .profile-post-content img {
        cursor: zoom-in;
        width: auto;
    }
    .el-carousel__item>img {
        height: inherit;
    }

    .full-page .link-list-info {
        background: #fff !important;
    }

    .ing_post {
        margin: 0px;
        text-align: left;
        padding-left: 50px;
        padding-bottom: 20px;
        padding-right: 50px;
        max-width: 800px;
        word-break: break-word;
    }

    .adj_img {
        padding-right: 10px;
    }

    .toghumImg img {
        object-fit: contain;
    }

    .toghumImg {
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;
    }

    .el-carousel__arrow {
        //top: 36% !important;
    }
</style>
<template>
    <div style="">
        <div style="padding-bottom: 0px" class="link-list-info flex-space normal">
            <div>

                <div class="info">
                    <router-link
                            class="post_info"
                            v-text="submission.channel_title"
                            :to="channelUrl(submission.channel_name)"
                    ></router-link>
                    <router-link :to="/l/+submission.location.slug">({{submission.location.name}})</router-link>
                    <!--<span class="set_background_color">Law</span>-->
                    <!--<router-link class="post_info" v-text="list.channel_name"-->
                    <!--:to="channelUrl(list.channel_name)"></router-link>-->
                    <router-link
                            v-if="!submission.deleted_by"
                            class="post_info"
                            v-text="'posted by ' + submission.author.username"
                            :to="userUrl(submission.author.username)"
                    ></router-link>
                    <span v-else class="post_info" v-text="'[deleted]'"></span>
                    <span>
            <router-link class="date time_ago" v-text="date" :to="url_2"></router-link>
          </span>
                </div>
                <a class="submisison-small-thumbnail" v-if="submission.content.thumbnail_path && !full">
                    <!-- img -->
                    <div
                            v-if="showSmallThumbnail"
                            class="small-thumbnail zoom-in"
                            :style="thumbnail"
                            @click="$emit('zoom', submission.content)"
                    ></div>
                </a>

                <div class="flex1">
                    <router-link
                            :to="'/p/' + submission.slug"
                            class="flex-space v-ultra-bold"
                            v-if="!full"
                    >
                        {{ submission.title }}
                        <el-tag size="mini" type="danger" class="margin-left-half" v-if="submission.nsfw">NSFW</el-tag>
                    </router-link>

                    <h1 style="margin-bottom: 0px" class="submission-title" v-else>
                        {{ submission.title }}
                        <el-tag size="mini" type="danger" class="margin-left-half" v-if="submission.nsfw">NSFW</el-tag>
                    </h1>
                    <submission-footer
                            :url="url"
                            :comments="comments"
                            :bookmarked="bookmarked"
                            :submission="submission"
                            v-if="!full"
                            @bookmark="$emit('bookmark')"
                            @report="$emit('report')"
                            @hide="$emit('hide')"
                            @nsfw="$emit('nsfw')"
                            @sfw="$emit('sfw')"
                            @destroy="$emit('destroy')"
                            @approve="$emit('approve')"
                            @disapprove="$emit('disapprove')"
                            @removethumbnail="$emit('removethumbnail')"
                            :liked="liked"
                            :points="points"
                            @like="$emit('like')"
                    ></submission-footer>
                </div>
            </div>
        </div>


        <div class="toghumImg" v-if="!isAlbum && showBigThumbnail">
            <img :src="submission.content.thumbnail_path"
                 :alt="submission.title"
                 @click="$emit('zoom', submission.content)"
                 class="big-thumbnail"/>
        </div>

        <div class="toghumImg" v-if="isAlbum && showBigThumbnail">
            <el-carousel
                    :height="isMobile ? '300px' : '700px'"
                    :autoplay="false"
                    arrow="always"
                    style="background:black;">

                <el-carousel-item v-for="item in photos" :key="item.id">
                    <img :src="item.thumbnail_path" @click="$emit('zoom', item)" :alt="submission.title">
                </el-carousel-item>
            </el-carousel>
        </div>

        <!--<p >{{submission.content.description}}</p>-->
        <div v-if="submission.content.description !== 'null'" class="ing_post" style="margin: 0px"
             v-html="submission.content.description"></div>
    </div>
</template>

<script>
    import SubmissionFooter from "../../components/SubmissionFooter.vue";
    import Helpers from "../../mixins/Helpers";

    export default {
        mixins: [Helpers],
        components: {
            SubmissionFooter
        },

        mixins: [Helpers],

        props: {
            nsfw: {},
            submission: {},
            bookmarked: {},
            url: {},
            comments: {},
            liked: {},
            points: {},
            full: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                photos: [],
                currentImageIndex: 0
            };
        },

        computed: {
            url_2() {
                return this.submissionUrl(this.submission);
            },
            date() {
                return this.parsDiffForHumans(this.submission.created_at);
            },
            thumbnail() {
                return {
                    backgroundImage: "url(" + this.submission.content.thumbnail_path + ")"
                };
            },

            isAlbum() {
                return this.photos.length > 1;
            },

            showBigThumbnail() {
                if (this.full) return true;

                if (this.nsfw) return false;

                return false;
            },

            showSmallThumbnail() {
                return !this.showBigThumbnail && !this.nsfw;
            }
        },

        created: function () {
            if (this.full) {
                this.getPhotos();
            }
        },

        methods: {
            setCurrentImage(index) {
                this.currentImageIndex = index;
            },

            getPhotos() {
                axios
                    .get("/submissions/photos", {
                        params: {
                            submission_id: this.submission.id
                        }
                    })
                    .then(response => {
                        this.photos = response.data.data;
                    });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/submission/ImgSubmission.vue